<template>
	<div class="addEdit-block" :style='{"padding":"30px","fontSize":"16px","color":"#666","background":"none"}'>
		<el-form
			:style='{"border":"1px solid #eee","padding":"30px","boxShadow":"0 0px 0px rgba(64, 158, 255, .3)","fontSize":"inherit","borderRadius":"6px","background":"#fff"}'
			class="add-update-preview"
			ref="ruleForm"
			:model="ruleForm"
			:rules="rules"
			label-width="150px"
		>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'"  label="文章标题" prop="title">
				<el-input  v-model="ruleForm.title" placeholder="文章标题" clearable  :readonly="ro.title"></el-input>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="文章标题" prop="title">
				<el-input v-model="ruleForm.title" placeholder="文章标题" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="文章分类" prop="categoryId">
				<el-select v-model="ruleForm.categoryId" placeholder="请选择文章分类" @change="categoryChange">
					<el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="文章分类" prop="categoryName">
				<el-tag type="primary">{{ruleForm.categoryName}}</el-tag>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'"  label="作者" prop="author">
				<el-input  v-model="ruleForm.author" placeholder="作者" clearable  :readonly="ro.author"></el-input>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="作者" prop="author">
				<el-input v-model="ruleForm.author" placeholder="作者" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="date" v-if="type!='info'" label="发布时间" prop="publishTime">
				<el-date-picker
					format="yyyy 年 MM 月 dd 日 HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					v-model="ruleForm.publishTime" 
					type="datetime"
					:readonly="ro.publishTime"
					placeholder="发布时间"
				></el-date-picker> 
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-else-if="ruleForm.publishTime" label="发布时间" prop="publishTime">
				<el-input v-model="ruleForm.publishTime" placeholder="发布时间" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="upload" v-if="type!='info' && !ro.coverImage" label="封面图片" prop="coverImage">
				<file-upload
					tip="点击上传封面图片"
					action="file/upload"
					:limit="1"
					:multiple="false"
					:fileUrls="ruleForm.coverImage?ruleForm.coverImage:''"
					@change="coverImageUploadChange"
				></file-upload>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="upload" v-else-if="ruleForm.coverImage" label="封面图片" prop="coverImage">
				<img v-if="ruleForm.coverImage.substring(0,4)=='http'" class="upload-img" style="margin-right:20px;" :src="ruleForm.coverImage.split(',')[0]" width="150" height="150">
				<img v-else class="upload-img" style="margin-right:20px;" v-for="(item,index) in ruleForm.coverImage.split(',')" v-bind:key="index" :src="$base.url+item" width="150" height="150">
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="textarea" v-if="type!='info'" label="文章摘要" prop="summary">
				<el-input
				  style="min-width: 200px; max-width: 600px;"
				  type="textarea"
				  :rows="4"
				  placeholder="文章摘要"
				  v-model="ruleForm.summary" >
				</el-input>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else-if="ruleForm.summary" label="文章摘要" prop="summary">
				<span :style='{"fontSize":"inherit","lineHeight":"40px","color":"inherit","fontWeight":"500","display":"inline-block"}'>{{ruleForm.summary}}</span>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-if="type!='info'"  label="文章内容" prop="content">
				<editor 
					style="min-width: 200px; max-width: 800px;"
					v-model="ruleForm.content" 
					class="editor" 
					action="file/upload">
				</editor>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else-if="ruleForm.content" label="文章内容" prop="content">
                <span :style='{"fontSize":"inherit","lineHeight":"40px","color":"inherit","fontWeight":"500","display":"inline-block"}' v-html="ruleForm.content"></span>
            </el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="是否置顶" prop="isTop">
				<el-select v-model="ruleForm.isTop" placeholder="请选择">
					<el-option label="是" :value="1"></el-option>
					<el-option label="否" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="是否置顶" prop="isTop">
				<el-tag v-if="ruleForm.isTop==1" type="warning">是</el-tag>
				<el-tag v-else type="info">否</el-tag>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="是否推荐" prop="isRecommend">
				<el-select v-model="ruleForm.isRecommend" placeholder="请选择">
					<el-option label="是" :value="1"></el-option>
					<el-option label="否" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="是否推荐" prop="isRecommend">
				<el-tag v-if="ruleForm.isRecommend==1" type="success">是</el-tag>
				<el-tag v-else type="info">否</el-tag>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="状态" prop="status">
				<el-select v-model="ruleForm.status" placeholder="请选择状态">
					<el-option label="草稿" :value="0"></el-option>
					<el-option label="已发布" :value="1"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="状态" prop="status">
				<el-tag v-if="ruleForm.status==1" type="success">已发布</el-tag>
				<el-tag v-else type="warning">草稿</el-tag>
			</el-form-item>
			
			<el-form-item :style='{"width":"100%","padding":"0","margin":"0","fontSize":"inherit","textAlign":"center"}' class="btn">
				<el-button class="btn3"  v-if="type!='info'" type="success" @click="onSubmit">
					<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
					保存
				</el-button>
				<el-button class="btn4" v-if="type!='info'" type="success" @click="back()">
					<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					取消
				</el-button>
				<el-button class="btn5" v-if="type=='info'" type="success" @click="back()">
					<span class="icon iconfont icon-fanhui" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					返回
				</el-button>
			</el-form-item>
		</el-form>
  </div>
</template>
<script>
export default {
	data() {
		return {
			id: '',
			type: '',
			categoryList: [],
			ro: {
				title: false,
				categoryId: false,
				author: false,
				summary: false,
				coverImage: false,
				content: false,
				publishTime: false,
				isTop: false,
				isRecommend: false,
				status: false
			},
			ruleForm: {
				title: '',
				categoryId: '',
				categoryName: '',
				author: '',
				summary: '',
				coverImage: '',
				content: '',
				publishTime: '',
				isTop: 0,
				isRecommend: 0,
				status: 1,
				viewCount: 0,
				likeCount: 0
			},
			rules: {
				title: [
					{ required: true, message: '文章标题不能为空', trigger: 'blur' }
				],
				categoryId: [
					{ required: true, message: '请选择文章分类', trigger: 'change' }
				],
				content: [
					{ required: true, message: '文章内容不能为空', trigger: 'blur' }
				]
			}
		};
	},
	props: ["parent"],
	computed: {},
	created() {
		this.getCategoryList();
	},
	mounted() {},
	methods: {
		// 获取分类列表
		getCategoryList() {
			this.$http({
				url: "articleCategory/list",
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.categoryList = data.data;
				}
			});
		},
		// 分类改变
		categoryChange(val) {
			let category = this.categoryList.find(item => item.id === val);
			if (category) {
				this.ruleForm.categoryName = category.categoryName;
			}
		},
		// 封面图片上传成功回调
		coverImageUploadChange(fileUrls) {
			this.ruleForm.coverImage = fileUrls;
		},
		init(id, type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if (this.type == 'info' || this.type == 'else') {
				this.info(id);
			} else if (this.id) {
				this.info(id);
			}
		},
		// 获取信息
		info(id) {
			this.$http({
				url: `article/info/${id}`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data;
				}
			});
		},
		// 提交
		onSubmit() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					this.$http({
						url: `article/${!this.ruleForm.id ? "save" : "update"}`,
						method: "post",
						data: this.ruleForm
					}).then(({ data }) => {
						if (data && data.code === 0) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.parent.showFlag = true;
									this.parent.search();
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					});
				}
			});
		},
		// 返回
		back() {
			this.parent.showFlag = true;
			if (this.type != 'info') {
				this.parent.search();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
</style>

